import React, { Component } from 'react'
import { Layout } from 'antd';

const { Footer } = Layout;

class FooterBar extends Component {
    render() {
        return (
            <Footer style={{ textAlign: 'center', padding: 20}}>SMS Portal ©2020</Footer>
        )
    }
}

export default FooterBar;
